import styled from 'styled-components';

export const Container = styled.div`
position:fixed;
width:100%;
height:100vh;
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
background: #F3F3FD;
`;


export const HeaderText = styled.span`
margin-top:32px;
font-family: Nunito;
font-style: normal;
font-weight: bold;
font-size: 20px;
line-height: 140%;
color:#314259;
`;

export const IllustrationText = styled.span`
margin-top:8px;
margin-left:5%;
margin-right:5%;
font-family: Nunito;
font-style: normal;
font-weight: 600;
font-size: 14px;
line-height: 22px;
text-align: center;
color: #263345;
`;

export const Refresh = styled.div`
margin-top:16px;
width:115px;
height:20px;
display:flex;
flex-diretion:row;
align-items:center;
justify-content:space-between;
font-family: Nunito;
font-style: normal;
font-weight: 700;
font-size: 14px;
line-height: 20px;
color: #454ADE;
`;